export const FacebookIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='23' height='22' viewBox='0 0 23 22' fill='none'>
    <path
      d='M16.8985 2.64062H7.48278C5.22275 2.64062 3.39062 4.50961 3.39062 6.81512V16.0661C3.39062 18.3716 5.22275 20.2406 7.48278 20.2406H16.8985C19.1585 20.2406 20.9906 18.3716 20.9906 16.0661V6.81512C20.9906 4.50961 19.1585 2.64062 16.8985 2.64062Z'
      stroke='#5E6C88'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
    />
    <path
      d='M11.3802 8.7436V9.95535H10.4297V11.4364H11.3802V15.8391H13.3341V11.4364H14.6449C14.6449 11.4364 14.7684 10.7262 14.8278 9.94921H13.3416V8.93721C13.3416 8.78497 13.5548 8.58169 13.766 8.58169H14.8297V7.03906H13.3822C11.3321 7.03906 11.3802 8.5218 11.3802 8.7436Z'
      fill='#5E6C88'
    />
  </svg>
);
